// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1j1Qc","type":"styles_type__MnzSi","choices":"styles_choices__3H6aN"};